import { render, staticRenderFns } from "./FBMType.vue?vue&type=template&id=40d53334&scoped=true"
import script from "./FBMType.vue?vue&type=script&lang=js"
export * from "./FBMType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d53334",
  null
  
)

export default component.exports